import React from 'react'
import { useContent } from '../contexts/ContentContext'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const Hero: React.FC = () => {
  const { content, isLoading } = useContent()
  const { ref, isVisible } = useScrollAnimation()
  
  const scrollToCollections = () => {
    const collectionsSection = document.getElementById('colecciones')
    if (collectionsSection) {
      collectionsSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const scrollToContact = () => {
    const contactSection = document.getElementById('contacto')
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  if (isLoading) {
    return (
      <section id="inicio" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-verano-background to-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando contenido...</p>
        </div>
      </section>
    )
  }

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-verano-background to-white pt-20">
      {/* Background Image/Video placeholder */}
      <div className="absolute inset-0 bg-gradient-to-r from-verano-primary/20 to-verano-secondary/20"></div>

      <div ref={ref} className={`relative z-10 container-max text-center ${isVisible ? 'animate-fade-in-up' : ''}`}>
        <div className="max-w-4xl mx-auto">
          {/* Logo de marca centrado */}
          <div className="flex justify-center mb-6">
            <img
              src="/logos/logo-rosa.png"
              alt="Jenny Kids"
              className="h-36 md:h-44 w-auto object-contain drop-shadow-md"
            />
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-gray-800 mb-6">
            {content.hero?.title || 'Jenny Kids'}
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8">
            {content.hero?.subtitle || 'Ropa infantil moderna y cómoda para tus pequeños'}
          </p>
          <p className="text-lg text-gray-500 mb-12 max-w-2xl mx-auto">
            {content.hero?.description || 'Descubre nuestras colecciones únicas diseñadas especialmente para niños y niñas. Calidad, estilo y comodidad en cada prenda.'}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToCollections}
              className="bg-black text-white font-semibold text-lg px-8 py-4 rounded-lg hover:bg-gray-800 transition-colors duration-200"
            >
              {content.hero?.cta_primary || 'Ver Colecciones'}
            </button>
            <button 
              onClick={scrollToContact}
              className="bg-black text-white font-semibold text-lg px-8 py-4 rounded-lg hover:bg-gray-800 transition-colors duration-200"
            >
              {content.hero?.cta_secondary || 'Suscribirse'}
            </button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Hero

